module.exports = __webpack_public_path__ + "img/icon_quick_sns.7ae34f45.svg";